import { MobiDocument } from "./MobiDocument";
import { Inscription } from './Inscription';
import { TarifEventSchedulerActiviteDocument } from './TarifEventSchedulerActiviteDocument';
import { Pointage } from './Pointage';
import { PointageInoeDocument } from './PointageInoeDocument';
import { PointageDetailInoeDocument } from './PointageDetailInoeDocument';
import { PaletteCategorieActiviteDocument } from './PaletteCategorieActiviteDocument';
import { TarifActiviteDocument } from './TarifActiviteDocument';
import { TarifActiviteElementFriseDocument } from './TarifActiviteElementFriseDocument';
import { SupplementPointageDocument } from './SupplementPointageDocument';
import { GroupeIndividu } from './GroupeIndividu';
import { GroupeActivite } from './GroupeActivite';
import { ElementFriseActiviteDocument } from './ElementFriseActiviteDocument';
import { Supplement } from './Supplement';
import { PaletteDocument } from './PaletteDocument';

export class Activite extends MobiDocument {
    //Attributs from DB
    private _id: string;
    private _rev: string;
    private id: number;
    private etablissement_id: number;
    private type_id: number;



    private date_debut: string
    private date_fin: string
    private categorie_nom: string
    private intitule_periode: string
    private pointage: string
    private horaires_fixes: boolean
    private jours: string
    private groupes: boolean

    public constructor(activite: any) {
        super();
        this._id = activite._id;
        this._rev = activite._rev;
        this.id = activite.id;
        this.etablissement_id = activite.etablissement_id
        this.type_id = activite.type_id
        this.date_debut = activite.date_debut
        this.date_fin = activite.date_fin
        this.categorie_nom = activite.categorie_nom
        this.intitule_periode = activite.intitule_periode
        this.pointage = activite.pointage
        this.horaires_fixes = activite.horaires_fixes
        this.jours = activite.jours
        this.groupes = activite.groupes
    }



    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getEtablissement_id(): number {
        return this.etablissement_id;
    }

    public setEtablissement_id(etablissement_id: number): void {
        this.etablissement_id = etablissement_id;
    }

    public getType_id(): number {
        return this.type_id;
    }

    public setType_id(type_id: number): void {
        this.type_id = type_id;
    }

    public getDate_debut(): string {
        return this.date_debut;
    }

    public setDate_debut(date_debut: string): void {
        this.date_debut = date_debut;
    }

    public getDate_fin(): string {
        return this.date_fin;
    }

    public setDate_fin(date_fin: string): void {
        this.date_fin = date_fin;
    }

    public getCategorie_nom(): string {
        return this.categorie_nom;
    }

    public setCategorie_nom(categorie_nom: string): void {
        this.categorie_nom = categorie_nom;
    }

    public getIntitule_periode(): string {
        return this.intitule_periode;
    }

    public setIntitule_periode(intitule_periode: string): void {
        this.intitule_periode = intitule_periode;
    }

    public getPointage(): string {
        return this.pointage;
    }

    public setPointage(pointage: string): void {
        this.pointage = pointage;
    }

    public isHoraires_fixes(): boolean {
        return this.horaires_fixes;
    }

    public setHoraires_fixes(horaires_fixes: boolean): void {
        this.horaires_fixes = horaires_fixes;
    }

    public getJours(): string {
        return this.jours;
    }

    public setJours(jours: string): void {
        this.jours = jours;
    }

    public isGroupes(): boolean {
        return this.groupes;
    }

    public setGroupes(groupes: boolean): void {
        this.groupes = groupes;
    }

    public getInscriptions(): Array<Inscription> {
        return this.memdb.find({
            doctype: "InscriptionDocument",
            fkey: "activite_id",
            fvalue: this.id
        });
    }

    public getSeances(date: string): Array<TarifEventSchedulerActiviteDocument> {
        let listTarifEventFinal: Array<TarifEventSchedulerActiviteDocument> = [];
        let listTarifEvent: Array<TarifEventSchedulerActiviteDocument> = this.memdb.find({
            doctype: "TarifEventSchedulerActiviteDocument",
            fkey: "activite_id",
            fvalue: this.id
        });
        listTarifEvent = listTarifEvent
            .filter((tarifEvent: TarifEventSchedulerActiviteDocument) =>
                tarifEvent.getDate() === date &&
                (tarifEvent.getResource_id() === "AC" ||
                    tarifEvent.getResource_id() === "TS" ||
                    tarifEvent.getResource_id() === "JO")
            ).sort(((a: TarifEventSchedulerActiviteDocument, b: TarifEventSchedulerActiviteDocument) =>
                a.getStart_date().localeCompare(b.getStart_date())));

        listTarifEvent.forEach((tarifEvent: TarifEventSchedulerActiviteDocument) => {
            if (typeof tarifEvent.getPlageFonctionnement_id() !== 'undefined') {

                let plage = tarifEvent.getPlageFonctionnement();
                if (plage.getAbreviation().length < 1)
                    tarifEvent.setPlageIntitule(plage.getIntitule());
                else
                    tarifEvent.setPlageIntitule(plage.getAbreviation());
                let elem = tarifEvent.getElementFriseActivite(this.id);
                if (typeof elem !== 'undefined')
                    tarifEvent.setFriseElement_id(elem.getId());
            } else {

                if (typeof tarifEvent.getService_id() !== 'undefined') {
                    let elem = tarifEvent.getService(this.id);
                    if (typeof elem !== 'undefined') {
                        tarifEvent.setFriseElement_id(elem.getId());
                        tarifEvent.setPlageIntitule(tarifEvent.getName());
                    }
                } else {
                    if (tarifEvent.getResource_id() === "JO") {               
                        let elem = tarifEvent.getElementFriseActiviteWithDate(this.id);
                         if (typeof elem !== 'undefined') {
                            let plage = elem.getPlageFonctionnement(); 
                            if (typeof plage !== 'undefined') {
                                let plage;
                                if(tarifEvent.getPlageFonctionnement_id() === null || tarifEvent.getPlageFonctionnement_id()===undefined) tarifEvent.setPlageFonctionnement_id(-8); //initialiser l'id plageFonctionnementDocument a -8 qaund il s'agit d'une activité de type séjour avec champ plageFonctionnementId=undefined et sevice_id=undefined
                                plage = tarifEvent.getPlageFonctionnement()
                                if (plage.getAbreviation().length < 1)
                                    tarifEvent.setPlageIntitule(plage.getIntitule());  
                                else
                                    tarifEvent.setPlageIntitule(plage.getAbreviation());
                                tarifEvent.setPlageFonctionnement_id(plage.getId());
                                tarifEvent.setFriseElement_id(elem.getId());
                            }
                        }
                    } else {
                        let tarif = tarifEvent.getTempsSup(this.id);
                        if (typeof tarif !== 'undefined') {
                            tarifEvent.setPlageIntitule(tarif.getPlageIntitule());
                            tarifEvent.setTempsTarif_id(tarif.getId());
                        }
                    }

                }
            }
            listTarifEventFinal.push(tarifEvent);
        });
        return listTarifEventFinal.sort(((a: TarifEventSchedulerActiviteDocument, b: TarifEventSchedulerActiviteDocument) =>
            a.getStart_date().localeCompare(b.getStart_date())));
    }

    public getPointagePrévi(date: string, paletteAbs: Array<number>): Array<any> {
        let paletteAnnul : Array<number> = [-34, -35];
        let listpointageprevi: Array<any> = [];
        let listInscriptionsId = this.getInscriptions().map((inscription: Inscription) => inscription.getId());
        let listPointages: Array<PointageInoeDocument> = this.memdb.findAll({ doctype: "PointageDocument" });
        if (typeof listPointages === 'undefined' || listPointages.length === 0) {
            return listpointageprevi;
        }
        listPointages = listPointages.filter((pointage: PointageInoeDocument) =>
            pointage.getDate() === date &&
            pointage.getType() === "PREVISIONNEL" &&
            listInscriptionsId.includes(pointage.getSchedulable_id())
        );
        listPointages.forEach((pointage: PointageInoeDocument) => {
            if (pointage.getIndividu() != null){
                let listPointagesDetails: Array<PointageDetailInoeDocument> = pointage.getPointagesDetails();
                listPointagesDetails.forEach((pdetail: PointageDetailInoeDocument) => {
                    if (!paletteAbs.includes(pdetail.getPalette_id())
                        && !paletteAnnul.includes(pdetail.getPalette_id())
                        && pdetail.getOrdrelisteattente() === 0
                        && pdetail.getOrdrelisteattentegroupe() === 0) {
                            console.log('pdetail ... ' ,pdetail)
                        if (typeof pdetail.getElementfrise_id() !== 'undefined') {
                            listpointageprevi.push({
                                elementfrise_id: pdetail.getElementfrise_id(),
                                individu_id: pointage.getIndividu().getId(),
                                palette_id: pdetail.getPalette_id(),
                                heure_arrive: pdetail.getTempsdebut(),
                                heure_depart: pdetail.getTempsfin()
                            })
                        } else {
                            if (typeof pdetail.getTariftempssupplactivite_id() !== 'undefined')
                                listpointageprevi.push({
                                    tariftempssupplactivite_id: pdetail.getTariftempssupplactivite_id(),
                                    individu_id: pointage.getIndividu().getId(),
                                    palette_id: pdetail.getPalette_id(),
                                    heure_arrive: pdetail.getTempsdebut(),
                                    heure_depart: pdetail.getTempsfin()
                                })
                        }
                    }
                });
            }
        });
        return listpointageprevi;
    }

    public getPointageRéel(date: string): Array<Pointage> {
        let listPointageReel: Array<Pointage> = [];
        let listPointages: Array<PointageInoeDocument> = this.memdb.findAll({ doctype: "PointageDocument" });
        let listInscriptionsId = this.getInscriptions().map((inscription: Inscription) => inscription.getId());
        if (typeof listPointages === 'undefined' || listPointages.length === 0) {
            return listPointageReel;
        }
        listPointages = listPointages.filter((pointage: PointageInoeDocument) =>
            pointage.getDate() === date &&
            pointage.getType() === "REEL" &&
            listInscriptionsId.includes(pointage.getSchedulable_id())
        );
        listPointages.forEach((pointage: PointageInoeDocument) => {
                if (pointage.getIndividu() != null){
                    let listPointagesDetails: Array<PointageDetailInoeDocument> = pointage.getPointagesDetails();
                    listPointagesDetails.forEach((pdetail: PointageDetailInoeDocument) => {
                    let pointageinoe = new Pointage({});
                    pointageinoe.setIdInscription(pointage.getSchedulable_id());
                    pointageinoe.setTempsDebut(pointage.getDate() + " " + pdetail.getTempsdebut());
                    pointageinoe.setTempsFin(pointage.getDate() + " " + pdetail.getTempsfin());
                    pointageinoe.setPaletteId(pdetail.getPalette_id());
                    let date: string = pointage.getDate();
                    pointageinoe.setDatePointage(date.replace(/-/g, ''));
                    pointageinoe.setTypePointage("REEL");
                    pointageinoe.setIdIndividu(pointage.getIndividu().getId());
                    pointageinoe.setIsInoe(true);
                    pointageinoe.setUsername("Inoe");
                    pointageinoe.setPdetail_id(pdetail.getId());

                    if (typeof pdetail.getElementfrise_id() !== 'undefined') {
                        pointageinoe.setElementFriseId(pdetail.getElementfrise_id());
                        pointageinoe.set_id("pointageAN" + pointageinoe.getDatePointage() + this.id + pointageinoe.getElementFriseId() + pointageinoe.getIdIndividu());
                    } else {
                        if (typeof pdetail.getTariftempssupplactivite_id() !== 'undefined') {
                            pointageinoe.setTempsSupplementaireId(pdetail.getTariftempssupplactivite_id());
                            pointageinoe.set_id("pointageAN" + pointageinoe.getDatePointage() + this.id + pointageinoe.getTempsSupplementaireId() + pointageinoe.getIdIndividu());
                        }
                    }
                    listPointageReel.push(pointageinoe);
                });
            }
        });
        return listPointageReel;
    }

    public getPalette(): Array<number> {
        let listPaletteCategorie = this.memdb.find({
            doctype: "PaletteCategorieActiviteDocument",
            fkey: "categorieactivite_nom",
            fvalue: this.categorie_nom
        });
        return listPaletteCategorie.map((paletteCategorie: PaletteCategorieActiviteDocument) => paletteCategorie.getPalette_id())
    }

    public getSupplements(date: string): Array<TarifActiviteDocument> {
        let listSupplements: Array<TarifActiviteDocument> = [];
        let listTarifActivite: Array<TarifActiviteDocument> = [];
        let listTarifEvent: Array<TarifEventSchedulerActiviteDocument> = this.memdb.find({
            doctype: "TarifEventSchedulerActiviteDocument",
            fkey: "activite_id",
            fvalue: this.id
        });
        listTarifEvent = listTarifEvent
            .filter((tarifEvent: TarifEventSchedulerActiviteDocument) =>
                tarifEvent.getDate() === date &&
                (tarifEvent.getResource_id() === "SU")
            ).sort(((a: TarifEventSchedulerActiviteDocument, b: TarifEventSchedulerActiviteDocument) =>
                a.getStart_date().localeCompare(b.getStart_date())))

        listTarifEvent.forEach((tarifevent: TarifEventSchedulerActiviteDocument) => {
            listTarifActivite.push(tarifevent.getTarifActivite());
        });

        listTarifActivite.forEach((tarifActivite: TarifActiviteDocument) => {
            let isAuto = false;
            let tarifActiviteEleme: Array<TarifActiviteElementFriseDocument> = tarifActivite.getTarifActiviteElementFrise();
            if (tarifActiviteEleme.length > 0) {
                isAuto = true;
                tarifActivite.setElementfrise_id(tarifActiviteEleme
                    .map((item: TarifActiviteElementFriseDocument) => item.getElementfrise_id()));
            }
            tarifActivite.setIsAuto(isAuto);
            listSupplements.push(tarifActivite);
        });
        return listSupplements.sort((a: TarifActiviteDocument, b: TarifActiviteDocument) =>
            new Intl.Collator('fr', { usage: "sort" }).compare(a.getPlageIntitule(), b.getPlageIntitule()));
    }

    public getSupplementsPrévi(date: string): Array<any> {
        let ListSupplPrevi: Array<any> = [];
        let listPointages: Array<PointageInoeDocument> = this.memdb.findAll({ doctype: "PointageDocument" });
        let listInscriptionsId = this.getInscriptions().map((inscription: Inscription) => inscription.getId());
        if (typeof listPointages === 'undefined' || listPointages.length === 0) {
            return ListSupplPrevi;
        }
        listPointages = listPointages.filter((pointage: PointageInoeDocument) =>
            pointage.getDate() === date &&
            pointage.getType() === "PREVISIONNEL" &&
            listInscriptionsId.includes(pointage.getSchedulable_id())
        );
        listPointages.forEach((pointage: PointageInoeDocument) => {
            if (pointage.getIndividu() != null){
                let listSupplementsPointage: Array<SupplementPointageDocument> = pointage.getSupplementPointage();
                listSupplementsPointage.forEach((sup: SupplementPointageDocument) => {
                    let supplPrevi = {
                        supplement_id: sup.getSupplement_id(),
                        checked: sup.isChecked(),
                        individu_id: pointage.getIndividu().getId()
                    };
                    ListSupplPrevi.push(supplPrevi);
                })
            }

        })
        return ListSupplPrevi;
    }


    public getSupplementsRéel(date: string): Array<Supplement> {
        let ListSupplReel: Array<Supplement> = [];
        let listPointages: Array<PointageInoeDocument> = this.memdb.findAll({ doctype: "PointageDocument" });
        let listInscriptionsId = this.getInscriptions().map((inscription: Inscription) => inscription.getId());
        if (typeof listPointages === 'undefined' || listPointages.length === 0) {
            return ListSupplReel;
        }
        listPointages = listPointages.filter((pointage: PointageInoeDocument) =>
            pointage.getDate() === date &&
            pointage.getType() === "REEL" &&
            listInscriptionsId.includes(pointage.getSchedulable_id())
        );
        listPointages.forEach((pointage: PointageInoeDocument) => {
            if (pointage.getIndividu() != null){
                let listSupplementsPointage: Array<SupplementPointageDocument> = pointage.getSupplementPointage();
                listSupplementsPointage.forEach((sup: SupplementPointageDocument) => {
                    let supplement = new Supplement({});
                    let date: string = pointage.getDate();

                    supplement.setChecked(sup.isChecked());
                    supplement.setInscriptionId(pointage.getSchedulable_id());
                    supplement.setNomEnfant(pointage.getIndividu().getDisplayName());
                    supplement.setPointageDate(date);
                    supplement.setSupplementId(sup.getSupplement_id());
                    supplement.setTypePointage('REEL');
                    supplement.setTypeSupplement('SU');
                    supplement.setVersion(0);
                    supplement.setIsInoe(true);
                    supplement.setUsername("Inoe")
                    supplement.set_id("supplementAN" + date.replace(/-/g, '') + this.getId() + sup.getSupplement_id() + pointage.getIndividu().getId());
                    supplement.setPdetail_id(sup.getId());
                    ListSupplReel.push(supplement);
                })
            }

        })
        return ListSupplReel;
    }
    public getGroupesActivite(): Array<number> {
        let listGroupeActivite = this.memdb.find({
            doctype: "GroupeActiviteDocument",
            fkey: "activite_id",
            fvalue: this.id
        });
        return listGroupeActivite.map((groupeActivite: GroupeActivite) => groupeActivite.getGroupe_id())
    }

    public getElementFriseActivite(): Array<ElementFriseActiviteDocument> {
        return this.memdb.find({
            doctype: "ElementFriseActiviteDocument",
            fkey: "activite_id",
            fvalue: this.id
        });
    }
}